import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';

/**
 * @description sets the availability fields if applicable
 *
 * @param searchParams
 * @param morningAvailability boolean
 * @param middayAvailability boolean
 * @param eveningAvailability boolean
 *
 */
export const setAvailability = (
  searchParams: URLSearchParams,
  morningAvailability?: boolean,
  middayAvailability?: boolean,
  eveningAvailability?: boolean
): void => {
  if (morningAvailability) {
    searchParams.set(searchFilterKeysMap.morningAvailability, true.toString());
  }
  if (middayAvailability) {
    searchParams.set(searchFilterKeysMap.middayAvailability, true.toString());
  }
  if (eveningAvailability) {
    searchParams.set(searchFilterKeysMap.eveningAvailability, true.toString());
  }
};
